import { Box } from '@material-ui/core';
import LoadingButton from 'components/LoadingButton';
import TextField from 'components/TextField';
import i18n from 'i18n';
import { validateForm } from 'pages/signup/utils';
import { ChangeEvent, useState, FunctionComponent } from 'react';
import passwordResetStyles from '../styles';
import BackToLogin from './BackToLogin';

interface EmailFormI {
  onSave: (email: string) => void;
  isLoading: boolean;
}

const EmailForm: FunctionComponent<EmailFormI> = ({
  onSave,
  isLoading
}: EmailFormI) => {
  const classes = passwordResetStyles();

  const [formData, setFormData] = useState({
    email: '',
    errors: {
      email: ''
    }
  });

  const onChangeField = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    setFormData({
      ...formData,
      errors: {
        ...formData.errors,
        [name]: validateForm(name, value)
      },
      [e.currentTarget.name]: e.currentTarget.value
    });
  };

  return (
    <Box className={classes.body}>
      <TextField
        label={i18n.t('pages.signup.formLabel.email')}
        placeholder={i18n.t('pages.signup.placeholder.email')}
        name="email"
        fullWidth
        error={!!formData.errors.email}
        value={formData.email}
        onChange={onChangeField}
      />
      <LoadingButton
        label={i18n.t('button.resetPassword')}
        isLoading={isLoading}
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => onSave(formData.email)}
      />
      <BackToLogin />
    </Box>
  );
};

export default EmailForm;
